module.exports = __webpack_public_path__ + "static/img/sm_16.ac0c60f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/sm_16.png
// module id = YpaV
// module chunks = 0